export default "__VITE_ASSET__DL9tk_w8__"